//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'Items',
  props: {
    gutterBottom: Boolean,
    gutterTop: Boolean
  }
};
export { script as default };